<template>
  <a-modal
    title="转班"
    :maskClosable="false"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @cancel="handleCancel"
  >
    <div class="class-list">
      <div class="student" v-if="classList.length > 0">
        已选择转班学生：<span
          class="item"
          v-for="(item, index) in classInfo.selectedStudent"
          :key="index"
          >{{ item.studentName
          }}{{
            index != classInfo.selectedStudent.length - 1 ? "，" : ""
          }}</span
        >
        <div class="count">共{{ classInfo.selectedStudent.length }}名</div>
      </div>
      <!-- 表格数据 -->
      <a-table
        :columns="columns"
        :dataSource="classList"
        :pagination="false"
        :loading="loading"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="pushClass(record)">转入该班</a>
        </span>
        <span slot="gradeScope" slot-scope="text">
          {{ text | gradeScopeFilter }}
        </span>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import student from "../../../api/student";

import classSet from "../../../api/classSet";

const columns = [
  {
    title: "班级名称",
    dataIndex: "className",
  },
  {
    title: "课程名称",
    dataIndex: "courseName",
  },
  {
    title: "老师名称",
    dataIndex: "teacherName",
  },
  {
    title: "教室名称",
    dataIndex: "placeName",
  },
  {
    title: "适用年级",
    dataIndex: "gradeScope",
    scopedSlots: { customRender: "gradeScope" },
    width: 110,
  },
  {
    title: "报名人数",
    dataIndex: "successApplyCount",
  },
  {
    title: "容纳人数",
    dataIndex: "upperLimit",
  },
  {
    title: "班级状态",
    dataIndex: "statusText",
  },
  {
    title: "创建时间",
    dataIndex: "gmtCreate",
    sorter: true,
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "insertClass",
  data() {
    return {
      columns, //列标识数据
      visible: false,
      confirmLoading: false,
      classList: [], //学生列表
      loading: true,
      classInfo: null, //班级信息
    };
  },
  methods: {
    pushClass(value) {
      if (this.classInfo.selectedStudent.length == 0) {
        this.$message.warn("没有选择需要转班的学生，请返回选择");
        return;
      }
      let self = this;
      // 此次转班将超出${}班级的容纳人数上限，转班不成功，请重新安排
      const desc = `共有${this.classInfo.selectedStudent.length}名学生从「${this.classInfo.className}」转班至「${value.className}」班级。`;
      this.$confirm({
        title: "确定转班",
        okText: "确定",
        cancelText: "取消",
        content: desc,
        onOk() {
          const idList = [];
          self.classInfo.selectedStudent.map((item) => {
            idList.push(item.id);
          });
          let req = {
            id: value.id,
            oldClassId: self.classInfo.id,
            studentIds: idList.join(),
          };
          classSet.changeClass(req).then((res) => {
            self.$message.success("转班成功");
            self.handleCancel();
          });
        },
      });
    },

    //初始化，显示
    init(params) {
      console.log("当前的班级信息是：", params);
      this.visible = true;
      this.classInfo = params;
      this.listCanChangeClass();
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit("refreshList");
    },

    //获取班级列表
    listCanChangeClass() {
      this.loading = true;
      classSet.listCanChangeClass(this.classInfo.id).then((res) => {
        this.classList = res.data;
        console.log(this.classList);
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.class-list {
  height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: hidden;
  .oper {
    text-align: right;
    margin-bottom: 10px;
    > .export {
      margin-left: 10px;
    }
  }
}

.student {
  > .item {
    display: inline-block;
  }
  > .count {
    margin: 10px 0px;
    font-weight: 500;
  }
}
</style>